import { apiSlice } from "../../api/apiSlice";

export const collaboratorApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get Collaborator data
    getCollaborator: builder.query({
      query: (id) => `/collaborators/${id}`,
      providesTags: ["collaborator"],
    }),

    // Update Profile data by ID (for secondary profiles)
    getProfile: builder.query({
      query: (id) => `/profiles/${id}`,
      providesTags: (result, error, id) => [{ type: 'profile', id }],
      // Force refetch every time
      keepUnusedDataFor: 0,
    }),

    patchProfile: builder.mutation({
      query: ({ id, content }) => ({
        url: `/profiles/${id}`,
        method: "PATCH",
        body: { ...content },
      }),
      invalidatesTags: (result, error, { id }) => [
        "collaborator",
        { type: "profile", id },
      ],
    }),

    // Get vCard for a Collaborator
    // query: (id) => `/collaborators/${id}/vcard`,
    getvCard: builder.query({
      query: (id) => `/vcards/${id}`,
    }),

    // Update Collaborator data
    patchCollaborator: builder.mutation({
      query: ({ id, content }) => ({
        url: `/collaborators/${id}`,
        method: "PATCH",
        body: { ...content },
      }),
      invalidatesTags: ["collaborator"],
    }),

    // Upload collaborator image profile ***Profile picture BASE64***
    uploadProfileImage: builder.mutation({
      query: (base) => ({
        url: `/collaborators/profile-image-64`,
        method: "POST",
        body: { ...base },
      }),
      invalidatesTags: ["collaborator"],
    }),

    // Upload collaborator image profile ***Profile picture***
    uploadProfileImageFormData: builder.mutation({
      query: (imageFile) => {
        const bodyFormData = new FormData();
        bodyFormData.append("profile-image", imageFile);
        return {
          url: `/collaborators/profile-image`,
          method: "POST",
          body: bodyFormData,
          formData: true,
        };
      },
      invalidatesTags: ["collaborator"],
    }),

    // Upload Collaborator Image from ***ANY IMAGE***
    uploadImage: builder.mutation({
      query: (imageFile) => {
        const bodyFormData = new FormData();
        bodyFormData.append("image", imageFile);
        return {
          url: `/collaborators/images`,
          method: "POST",
          body: bodyFormData,
          formData: true,
        };
      },
    }),
    autoFillAi: builder.mutation({
      query: (imageFile) => {
        const bodyFormData = new FormData();
        bodyFormData.append("image", imageFile);
        return {
          url: `/identifications/extract-data`,
          method: "POST",
          body: bodyFormData,
          formData: true,
        };
      },
    }),

    // Upload Collaborator Image from ***image section***
    uploadCollaboratorImage: builder.mutation({
      query: (imageFile) => {
        const bodyFormData = new FormData();
        bodyFormData.append("image", imageFile);
        return {
          url: `/collaborators/upload-image`,
          method: "POST",
          body: bodyFormData,
          formData: true,
        };
      },
      invalidatesTags: ["collaborator"],
    }),

    // DELETE Collaborator Image from ***image section***
    deleteCollaboratorImage: builder.mutation({
      query: (content) => ({
        url: `collaborators/remove-image`,
        method: "DELETE",
        body: { ...content },
      }),
      invalidatesTags: ["collaborator"],
    }),

    changeCollabPass: builder.mutation({
      query: (base) => ({
        url: `/collaborators/change-password`,
        method: "POST",
        body: { ...base },
      }),
    }),

    checkSlug: builder.mutation({
      query: (content) => ({
        url: `/collaborators/check-slug`,
        method: "POST",
        body: { ...content },
      }),
    }),

    postForgotPassword: builder.mutation({
      query: (content) => ({
        url: `/collaborators/reset-password`,
        method: "POST",
        body: { ...content },
      }),
    }),

    //Create new Identification
    postCreateIdentif: builder.mutation({
      query: (content) => ({
        url: `/identifications`,
        method: "POST",
        body: { ...content },
      }),
    }),

    patchCreateIdentif: builder.mutation({
      query: ({ identifId, content }) => ({
        url: `/identifications/${identifId}`,
        method: "PATCH",
        body: { ...content },
      }),
    }),

    updateIdentificationTags: builder.mutation({
      query: ({ identifId, tags, notes }) => {
        const body = {};
        if (tags !== undefined) body.tags = tags;
        if (notes !== undefined) body.notes = notes;
        console.log("API Request - updateIdentificationTags:", {
          url: `/identifications/${identifId}/update`,
          body,
        });
        return {
          url: `/identifications/${identifId}/update`,
          method: "PATCH",
          body,
        };
      },
      invalidatesTags: (result, error, arg) => {
        const tags = ["collaborator"];
        if (arg.collaboratorId) {
          tags.push({
            type: "IdentificationContacts",
            id: arg.collaboratorId,
          });
        }
        return tags;
      },
    }),

    removeIdentificationTagFromVocabulary: builder.mutation({
      query: ({ collaboratorId, tag }) => ({
        url: `/identifications/contacts/tag-vocabulary/${collaboratorId}`,
        method: "PATCH",
        body: { tag },
      }),
      invalidatesTags: (result, error, arg) => [
        "collaborator",
        { type: "IdentificationContacts", id: arg.collaboratorId },
      ],
    }),

    tracking: builder.mutation({
      query: (content) => ({
        url: `/trackings`,
        method: "POST",
        body: { ...content },
      }),
    }),

    // upload picture publicaly
    uploadPublic: builder.mutation({
      query: (imageFile) => {
        const bodyFormData = new FormData();
        bodyFormData.append("file", imageFile);
        return {
          url: `/upload`,
          method: "POST",
          body: bodyFormData,
          formData: true,
        };
      },
    }),

    // get contact lock
    getContactLock: builder.query({
      query: (id) => `/collaborators/${id}/contact-lock`,
      // providesTags: ["collaborator"],
    }),

    //create contact lock
    postCreateLock: builder.mutation({
      query: (id) => ({
        url: `/collaborators/${id}/contact-lock`,
        method: "POST",
      }),
    }),

    //Check contact lock code
    checkContactLock: builder.mutation({
      query: ({ id, content }) => ({
        url: `/collaborators/${id}/contact-lock`,
        method: "PATCH",
        body: { ...content },
      }),
    }),

    //upload && delete pdf in links
    uploadPdf: builder.mutation({
      query: (pdfFile) => {
        const bodyFormData = new FormData();
        bodyFormData.append("pdf", pdfFile);
        return {
          url: `/medias/pdfs`,
          method: "POST",
          body: bodyFormData,
        };
      },
    }),

    deleteCollaboratorpdf: builder.mutation({
      query: (content) => ({
        url: `/medias/pdfs`,
        method: "DELETE",
        body: { ...content },
      }),
    }),

    searchIdentificationContacts: builder.query({
      query: ({ id, page = 1, limit = 20, startDate, endDate }) => {
        const params = new URLSearchParams({
          page: String(page),
          limit: String(limit),
        });
        if (startDate && endDate) {
          params.set("startDate", startDate);
          params.set("endDate", endDate);
        }
        return `/identifications/contacts/search/${id}?${params.toString()}`;
      },
      transformResponse: (response) => {
        const contacts =
          response?.data?.contacts ?? response?.contacts ?? [];
        const pagination =
          response?.pagination ?? response?.data?.pagination ?? {};
        return { contacts, pagination };
      },
      providesTags: (result, error, arg) =>
        arg?.id
          ? [{ type: "IdentificationContacts", id: arg.id }]
          : [],
    }),

    // Get an email with the current Qr code
    downloadQrCode: builder.query({
      query: (id) => `/collaborators/${id}/generateQrCode`,
    }),

    //Create Multi profile
    createNewProfile: builder.mutation({
      query: (content) => ({
        url: "/profiles",
        method: "Post",
        body: content,
      }),
      invalidatesTags: ["collaborator"],
    }),

    // updateProfilePicture: builder.mutation({
    //   query: (imageFile) => {
    //     const bodyFormData = new FormData();
    //     bodyFormData.append("profile-image", imageFile);
    //     return {
    //       url: `/collaborators/profile-image`,
    //       method: "POST",
    //       body: bodyFormData,
    //       formData: true,
    //     };
    //   },
    //   invalidatesTags: ["collaborator"],
    // }),
  }),
});

export const {
  useGetCollaboratorQuery,
  useGetProfileQuery,
  useLazyGetProfileQuery,
  usePatchProfileMutation,
  useGetvCardQuery,
  usePatchCollaboratorMutation,
  useUploadProfileImageMutation,
  useUploadProfileImageFormDataMutation,
  useUploadImageMutation,
  useAutoFillAiMutation,
  useUploadCollaboratorImageMutation,
  useDeleteCollaboratorImageMutation,
  useChangeCollabPassMutation,
  useCheckSlugMutation,
  usePostForgotPasswordMutation,
  usePostCreateIdentifMutation,
  usePatchCreateIdentifMutation,
  useUpdateIdentificationTagsMutation,
  useRemoveIdentificationTagFromVocabularyMutation,
  useTrackingMutation,
  useUploadPublicMutation,
  useGetContactLockQuery,
  usePostCreateLockMutation,
  useCheckContactLockMutation,
  useUploadPdfMutation,
  useDeleteCollaboratorpdfMutation,
  useSearchIdentificationContactsQuery,
  useDownloadQrCodeQuery,
  useCreateNewProfileMutation,
  // useUpdateProfilePictureMutation,
} = collaboratorApiSlice;
